module.exports = __webpack_public_path__ + "static/media/inService.a00dc513.svg";